import React from 'react';
import { connect } from 'react-redux';
import { apiActions, poppinFormActions, readingActions } from '../../../actions';
import { Poppin as PoppinView } from '../../design/Episode/Poppin';

class Poppin extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      posX: this.props.posX,
      posY: this.props.posY,
      dragging: false,
      dragged: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.dragging && !prevState.dragging) {
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    } else if (!this.state.dragging && prevState.dragging) {
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }

  calculatePosition(pos) {
    if (pos < 0) return 0;
    else if (pos > 1) return 1;
    else return pos;
  }

  onMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.button === 0) // only left mouse button
      this.setState({ dragging: true })
  }

  onMouseMove = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.state.dragging) return;
    const pagePosition = ReactDOM.findDOMNode(event.target.parentElement.parentElement).getBoundingClientRect();

    const posX = this.calculatePosition((event.clientX - pagePosition.left) / pagePosition.width);
    const posY = this.calculatePosition((event.clientY - pagePosition.top) / pagePosition.height);

    if (((pagePosition.left != 0 && pagePosition.bottom > 250) || pagePosition.top > 100) &&
      posX > 0 && posY > 0 && posX < 1 && posY < 1) {
      this.setState({
        posX: posX,
        posY: posY,
        dragged: true
      })
    }
  };

  onMouseUp = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.state.dragged) {
      this.props.openedPoppinToggle(this.props.id);
    } else if (this.props.owned) {
      this.props.poppinMovedStore(Object.assign({}, this.props, this.state))
    }

    this.setState({dragging: false, dragged: false});
  };

  render = () => (
    <PoppinView
      zIndex={this.props.opened ? 99999 : 1 + this.props.pinIdx}
      onMouseDown={this.onMouseDown.bind(this)}
      {...this.props}
      posX={this.state.posX}
      posY={this.state.posY}
    />
  );
}

const mapState = (state, ownProps) => ({
  opened: state.reading.openedPoppinId == ownProps.id,
  posX: ownProps.pos_x,
  posY: ownProps.pos_y
});

const mapDispatch = (dispatch, ownProps) => ({
  poppinMovedStore: (props) => {
    dispatch(apiActions.poppinMovedStore(ownProps.pinIdx, ownProps.pageIdx, props))
  },
  openedPoppinToggle: (id) => {
    dispatch(readingActions.openedPoppinToggle(id));
    dispatch(poppinFormActions.poppinFormClose());
  }
});

export default connect(mapState, mapDispatch)(Poppin);